import { Pipe, PipeTransform } from '@angular/core';

/*
 * Simple pipe to format a number to 2 digits and a comma
 *
 * @author evandongen
 */
@Pipe({
    name: 'numberFormat',
    standalone: true
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number, currency: boolean): string {
    // if (!value) doesn't work if the this a number with value '0'
    if (value === undefined || value === null) {
      return null;
    }

    const number = value.toFixed(2);

    if (currency) {
      return number.replace('.', ',');
    }

    return number;
  }
}
